import type { AppRegion } from '@/entities/region/Region'
import type { AuthState } from '@/features/auth/model/auth.types'
import { STORAGE_KEYS } from './storage.keys'

/**
 * Direct localStorage access layer for auth state
 * Used by non-React code that needs to access auth state directly
 */
export const authPersistence = {
  //
  // Getters
  //
  getState: (): AuthState => {
    const stored = localStorage.getItem(STORAGE_KEYS.AUTH_STATE)
    if (!stored) {
      return {
        token: null,
        tokenExpiry: null,
        region: null,
        projectId: null,
        destinationId: null,
        isLoading: true,
        error: null,
      }
    }
    const data = JSON.parse(stored)
    return data.state || data // Support both { state: {...} } and direct state
  },
  getAuthToken: (): string | null => {
    const state = authPersistence.getState()
    return state?.token || null
  },
  getRegion: (): AppRegion | null => {
    const state = authPersistence.getState()
    return state?.region || null
  },
  getDestinationId: (): string | null => {
    const state = authPersistence.getState()
    return state?.destinationId || null
  },

  //
  // Setters
  //
  setState: (state: AuthState): void => {
    localStorage.setItem(STORAGE_KEYS.AUTH_STATE, JSON.stringify({ state }))
  },
  setAuthToken: (token: string | null): void => {
    const state = authPersistence.getState()
    const newState = {
      ...state,
      token,
    }
    authPersistence.setState(newState)
  },
  setRegion: (region: AppRegion) => {
    const state = authPersistence.getState()
    authPersistence.setState({ ...state, region })
  },
  setDestinationId: (code: string) => {
    const state = authPersistence.getState()
    authPersistence.setState({ ...state, destinationId: code })
  },
  clearAllData: () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_STATE)
  },
}
